// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paymentContainer {
  /* padding: 20px; */
  max-width: 100%;
  margin: 0 !important;
  padding: 0 !important;
}

.paymentHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.refund-policy-button {
  background-color: #F0F2FF;
  border: 1px solid #E0E7FF;
  border-radius: 15px;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.2s;
  width: 275px;
  height: 52px;
}

.refund-policy-button:hover {
  background-color: #E0E7FF;
}

.refund-policy-button .arrow-icon {
  margin-left: 8px;
  font-size: 20px;
  color: #000 !important;
  font-weight: bold;
  position: relative;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pageTitle {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.paymentTableContainer {
  width: 100%;
  overflow-x: auto;
}

.paymentTable {
  width: 100%;
  border-collapse: collapse;
}

.paymentTable thead th {
  background-color: #E5E5E5 !important;
  color: #000000 !important;
  padding: 12px 15px;
  text-align: center;
  border: 1px solid #e0e0e0;
  font-weight: normal;
}

.paymentTable tbody td {
  padding: 10px 8px;
  text-align: center;
  border: 1px solid #e0e0e0;
  background-color: #ffffff !important;
  color: #000000 !important;
  font-size: 14px;
  word-wrap: break-word;
  white-space: normal;
  overflow-wrap: break-word;
  hyphens: auto;
}

.paymentTable th:nth-child(1), 
.paymentTable td:nth-child(1) {
  width: 15%;
}

.paymentTable th:nth-child(2), 
.paymentTable td:nth-child(2) {
  width: 30%;
}

.paymentTable th:nth-child(3), 
.paymentTable td:nth-child(3) {
  width: 10%;
}

.paymentTable th:nth-child(4), 
.paymentTable td:nth-child(4) {
  width: 20%;
}

.paymentTable th:nth-child(5), 
.paymentTable td:nth-child(5) {
  width: 20%;
}

.paymentTable th:nth-child(6), 
.paymentTable td:nth-child(6) {
  width: 30%;
}

.planLink {
  background: none;
  border: none;
  color: #000000 !important;
  text-decoration: none !important;
  cursor: pointer;
  font-weight: normal !important;
  font-size: 14px;
  padding: 0;
  text-align: center;
  max-width: 100%;
  display: inline-block;
  word-break: keep-all;
}

.planLink:hover {
  color: #000000 !important;
  text-decoration: underline !important;
  font-weight: bold !important;
}

.refundType, .purchaseType {
  color: #000000 !important;
}

/* 결제 타입별 스타일 */
.purchaseType {
  background-color: #e8f5e9 !important;
}

.refundType {
  background-color: #ffebee !important;
}

.extensionType {
  background-color: #e3f2fd !important;
}

/* 새로 추가한 스타일 */
.loadingMessage,
.errorMessage,
.emptyMessage {
  text-align: center;
  padding: 30px;
  font-size: 16px;
  color: #666;
}

.errorMessage {
  color: #e53935;
}

.retryButton {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.retryButton:hover {
  background-color: #e0e0e0;
}

/* 페이지네이션 스타일 */
.paginationContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0;
  gap: 10px;
}

.pageButton {
  padding: 8px 12px;
  border: 1px solid #ddd;
  background-color: #fff;
  color: #333;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s;
}

.pageButton:hover:not(:disabled) {
  background-color: #f5f5f5;
  border-color: #ccc;
}

.pageButton:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pageInfo {
  margin: 0 15px;
  font-size: 14px;
  color: #666;
} `, "",{"version":3,"sources":["webpack://./src/styles/Payment.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;EACf,8BAA8B;EAC9B,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,eAAe;AACf;;;EAGE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb","sourcesContent":[".paymentContainer {\n  /* padding: 20px; */\n  max-width: 100%;\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n.paymentHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n.refund-policy-button {\n  background-color: #F0F2FF;\n  border: 1px solid #E0E7FF;\n  border-radius: 15px;\n  color: #333;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 20px;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 500;\n  transition: all 0.2s;\n  width: 275px;\n  height: 52px;\n}\n\n.refund-policy-button:hover {\n  background-color: #E0E7FF;\n}\n\n.refund-policy-button .arrow-icon {\n  margin-left: 8px;\n  font-size: 20px;\n  color: #000 !important;\n  font-weight: bold;\n  position: relative;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pageTitle {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 30px;\n}\n\n.paymentTableContainer {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.paymentTable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.paymentTable thead th {\n  background-color: #E5E5E5 !important;\n  color: #000000 !important;\n  padding: 12px 15px;\n  text-align: center;\n  border: 1px solid #e0e0e0;\n  font-weight: normal;\n}\n\n.paymentTable tbody td {\n  padding: 10px 8px;\n  text-align: center;\n  border: 1px solid #e0e0e0;\n  background-color: #ffffff !important;\n  color: #000000 !important;\n  font-size: 14px;\n  word-wrap: break-word;\n  white-space: normal;\n  overflow-wrap: break-word;\n  hyphens: auto;\n}\n\n.paymentTable th:nth-child(1), \n.paymentTable td:nth-child(1) {\n  width: 15%;\n}\n\n.paymentTable th:nth-child(2), \n.paymentTable td:nth-child(2) {\n  width: 30%;\n}\n\n.paymentTable th:nth-child(3), \n.paymentTable td:nth-child(3) {\n  width: 10%;\n}\n\n.paymentTable th:nth-child(4), \n.paymentTable td:nth-child(4) {\n  width: 20%;\n}\n\n.paymentTable th:nth-child(5), \n.paymentTable td:nth-child(5) {\n  width: 20%;\n}\n\n.paymentTable th:nth-child(6), \n.paymentTable td:nth-child(6) {\n  width: 30%;\n}\n\n.planLink {\n  background: none;\n  border: none;\n  color: #000000 !important;\n  text-decoration: none !important;\n  cursor: pointer;\n  font-weight: normal !important;\n  font-size: 14px;\n  padding: 0;\n  text-align: center;\n  max-width: 100%;\n  display: inline-block;\n  word-break: keep-all;\n}\n\n.planLink:hover {\n  color: #000000 !important;\n  text-decoration: underline !important;\n  font-weight: bold !important;\n}\n\n.refundType, .purchaseType {\n  color: #000000 !important;\n}\n\n/* 결제 타입별 스타일 */\n.purchaseType {\n  background-color: #e8f5e9 !important;\n}\n\n.refundType {\n  background-color: #ffebee !important;\n}\n\n.extensionType {\n  background-color: #e3f2fd !important;\n}\n\n/* 새로 추가한 스타일 */\n.loadingMessage,\n.errorMessage,\n.emptyMessage {\n  text-align: center;\n  padding: 30px;\n  font-size: 16px;\n  color: #666;\n}\n\n.errorMessage {\n  color: #e53935;\n}\n\n.retryButton {\n  display: block;\n  margin: 20px auto;\n  padding: 10px 20px;\n  background-color: #f0f0f0;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.retryButton:hover {\n  background-color: #e0e0e0;\n}\n\n/* 페이지네이션 스타일 */\n.paginationContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 30px 0;\n  gap: 10px;\n}\n\n.pageButton {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  background-color: #fff;\n  color: #333;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.pageButton:hover:not(:disabled) {\n  background-color: #f5f5f5;\n  border-color: #ccc;\n}\n\n.pageButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pageInfo {\n  margin: 0 15px;\n  font-size: 14px;\n  color: #666;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
